import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { CodigoEppoEditComponent } from './codigoseppo/codigoeppo-edit.component';
import { CodigoEppoListComponent } from './codigoseppo/codigoeppo-list.component';
import { EspeciesGruposFormasEditComponent } from './especiesgruposformas/especiesgruposformas-edit.component';
import { EspeciesGruposFormasListComponent } from './especiesgruposformas/especiesgruposformas-list.component';
import { FormaEditSubformaListComponent } from './gruposformas/forma-edit-subforma-list.component';
import { GrupoEditFormaListComponent } from './gruposformas/grupo-edit-forma-list.component';
import { GrupoListComponent } from './gruposformas/grupo-list.component';
import { SubFormaEditComponent } from './gruposformas/subforma-edit.component';
import { NombrecientificoEditComponent } from './nombrescientificos/nombrecientifico-edit.component';
import { NombrecientificoListComponent } from './nombrescientificos/nombrecientifico-list.component';
import { RestriccionProductosExWrapperEditComponent } from './restriccionproductosex/restriccionproductoex-wrapper-edit/restriccionproductoex-wrapper-edit.component';
import { RestriccionProductosExWrapperComponent } from './restriccionproductosex/restriccionproductoex-wrapper/restriccionproductoex-wrapper.component';
import { VariedadWrapperEditComponent } from './variedades/variedad-wrapper-edit/variedad-wrapper-edit.component';
import { VariedadWrapperComponent } from './variedades/variedad-wrapper/variedad-wrapper.component';
import { OrganismosNocivosWrapperComponent } from './organismosnocivos/organismosnocivos-wrapper/organismosnocivos-wrapper.component';
import { OrganismosNocivosWrapperEditComponent } from './organismosnocivos/organismosnocivos-wrapper-edit/organismosnocivos-wrapper-edit.component';
import { PanelProductosWrapperComponent } from './panelproductos/panelproductos-wrapper/panelproductos-wrapper.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { ConfiguracionTaricWrapperComponent } from './configuraciontaric/configuraciontaric-wrapper/configuraciontaric-wrapper.component';
import { ConfiguracionTaricWrapperEditComponent } from './configuraciontaric/configuraciontaric-wrapper-edit/configuraciontaric-wrapper-edit.component';

const especiesRoutes: Routes = [
    //NOMBRES CIENTIFICOS
    {
        path: 'mantenimiento/especies/nombrescientificos',
        data: {
            breadcrumb: 'Nombres Científicos',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: NombrecientificoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: NombrecientificoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Nombre Científico',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: NombrecientificoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Nombre Científico',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //GRUPOS, FORMAS y SUBFORMAS
    {
        path: 'mantenimiento/especies/grupos',
        data: {
            breadcrumb: 'Grupos',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: GrupoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:idGrupo',

                data: {
                    breadcrumb: 'Editar Grupo',
                },
                children: [
                    {
                        path: '',
                        component: GrupoEditFormaListComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'formas/edit/:idForma',

                        data: {
                            breadcrumb: 'Editar Forma',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                        children: [
                            {
                                path: '',
                                component: FormaEditSubformaListComponent,
                                canActivate: [LoginGuard(), ActionGuard()],
                                data: {
                                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                                },
                            },
                            {
                                path: 'subformas/edit/:idSubforma',
                                component: SubFormaEditComponent,
                                canActivate: [LoginGuard(), ActionGuard()],
                                data: {
                                    breadcrumb: 'Editar Subforma',
                                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                                },
                            },
                            {
                                path: 'subformas/create',
                                component: SubFormaEditComponent,
                                canActivate: [LoginGuard(), ActionGuard()],
                                data: {
                                    breadcrumb: 'Nueva Subforma',
                                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                                },
                            },
                        ],
                    },
                    {
                        path: 'formas/create',
                        component: FormaEditSubformaListComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nueva Forma',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },
            {
                path: 'create',
                component: GrupoEditFormaListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Grupo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ESPECIES GRUPOS FORMAS (BUSCADOR DE ESPECIES)
    {
        path: 'mantenimiento/especies/especiesgruposformas',
        data: {
            breadcrumb: 'Buscador de Especies Vegetales',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: EspeciesGruposFormasListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EspeciesGruposFormasEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Especie Vegetal',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: EspeciesGruposFormasEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Especie Vegetal',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //CÓDIGOS EPPO
    {
        path: 'mantenimiento/especies/codigoseppo',
        data: {
            breadcrumb: 'Códigos Eppo',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: CodigoEppoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: CodigoEppoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Código Eppo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: CodigoEppoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Código Eppo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // VARIEDADES
    {
        path: 'mantenimiento/especies/variedades',
        data: {
            breadcrumb: 'Variedades',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: VariedadWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: VariedadWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Variedad',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: VariedadWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Variedad',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // RESTRICCIONES PRODUCTOS EXPORTACIÓN
    {
        path: 'mantenimiento/especies/restriccionproductosex',
        data: {
            breadcrumb: 'Restricciones Productos Exportación',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: RestriccionProductosExWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: RestriccionProductosExWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Restricción',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:idEspecie/:idPaisDestino',
                component: RestriccionProductosExWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Restricción',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'clone/:idEspecie/:idPaisDestino',
                component: RestriccionProductosExWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    clone: true,
                    breadcrumb: 'Clonar Restricción',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // ORGANISMOS NOCIVOS
    {
        path: 'mantenimiento/especies/organismosnocivos',
        data: {
            breadcrumb: 'Organismos Nocivos',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: OrganismosNocivosWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: OrganismosNocivosWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Organismo Nocivo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: OrganismosNocivosWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Organismo Nocivo',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // PANEL PRODUCTOS
    {
        path: 'mantenimiento/especies/panelproductos',
        data: {
            breadcrumb: 'Panel de Productos',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: PanelProductosWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // CONFIGURACIÓN DEL IMPORTADOR Y DEL LUGAR DE DESTINO POR TARIC
    {
        path: 'mantenimiento/especies/configuraciontaric',
        data: {
            breadcrumb: 'Configuración por Taric',
            menu0: 'MANTENIMIENTO',
            menu1: 'Especies',
        },
        children: [
            {
                path: '',
                component: ConfiguracionTaricWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: ConfiguracionTaricWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Configuración por Taric',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: ConfiguracionTaricWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Crear Configuración por Taric',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(especiesRoutes)],
    exports: [RouterModule],
})
export class EspeciesRoutingModule {}
